


























import ForgotScreen3 from 'components/ForgotScreen3.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    ForgotScreen3
  }
})
export default class ConfirmRegistration extends Vue {
  get method () {
    return String(this.$route.query.code).length === 32 ? 'email' : 'tel'
  }

  meta () {
    return {
      title: `${this.$t(this.$msg.NewPassword)}${this.$appConfig.titlePostfix}`
    }
  }
}
